import type { TierHero } from '../types';
import type { ScatterLayout } from './buildScatterPoints';
import { computeScatterAxisScales } from './buildScatterPoints';
import { clippedPolylinePathD } from './clipLineToRect';
import { getTierBoundarySampleData } from './tierBoundarySampling';

/**
 * tierScore = win% + β * バンピック% の等値線。座標はクランプせず矩形クリップする
 * （Y 上下に張り付いた水平キンクを防ぐ）。
 */
export function buildTierBoundaryPolylines(
  tierHeroes: TierHero[],
  beta: number,
  layout: ScatterLayout
): string[] {
  const scales = computeScatterAxisScales(tierHeroes);
  if (!scales) return [];

  const data = getTierBoundarySampleData(tierHeroes, beta, layout);
  if (!data) return [];

  const { xs, boundaryYs, w, h } = data;
  return boundaryYs
    .map((ys) => {
      const pts = xs.map((x, i) => ({ x, y: ys[i]! }));
      return clippedPolylinePathD(pts, w, h);
    })
    .filter((d) => d.length > 0);
}
